/**
 * roles — Catálogo ÚNICO de roles del sistema.
 *
 * Fuente de verdad para: User.role, Empleado.rol, rutas (App.tsx),
 * menú (navigation.config.ts) y guards (ProtectedRoute/HomeRedirect).
 * NUNCA repetir arrays de roles como literales en otros archivos.
 */
export const ROLES = [
  "vendedor",
  "cajero",
  "administrador",
  "dueño",
  "empleado",
  "mesero",
  "supervisor",
  "encargado",
  "recursos_humanos",
  "contador",
  "domiciliario",
  "repartidor",
] as const;

export type Role = (typeof ROLES)[number];

/** Dueño + administrador: roles de gestión total del negocio. */
export const OWNER_ADMIN_ROLES: Role[] = ["dueño", "administrador"];

/** Roles operativos: usan las vistas "Mi Tareas/Asistencia/Nómina/Perfil". */
export const OPERATIVE_ROLES: Role[] = [
  "vendedor",
  "cajero",
  "empleado",
  "mesero",
  "supervisor",
  "encargado",
  "recursos_humanos",
  "contador",
];

/** Roles con acceso a la app (todas las rutas internas). */
export const ALL_APP_ROLES: Role[] = [...OWNER_ADMIN_ROLES, ...OPERATIVE_ROLES];

/** Roles de reparto (tienda virtual / liquidaciones de domiciliarios). */
export const DELIVERY_ROLES: Role[] = ["domiciliario", "repartidor"];

/** Roles que operan la caja registradora (POS). */
export const CASHIER_ROLES: Role[] = ["cajero", "vendedor"];
